export default "__VITE_ASSET__BUR9V9J7__"